// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6943d5f1","455":"4d463712","977":"5e323ab7"}[chunkId] + ".chunk.js";
};